import { Question } from "./question.model"
import { RatingQuestion } from "./rating-question.model"
import { YesNoQuestion } from "./yes-no-question.model"
import { SelectQuestion } from "./select-question.model"
import { EssayQuestion } from "./essay-question.model"

export class Survey {

  public id: string;
  public name: string;
  public questions: Question[];

  constructor(
    obj?: any 
  ) {
    this.id = obj && obj.id && obj.id.toString() || null;
    this.name = obj && obj.name || null;


    if ( obj && obj.questions ) {
       this.questions = [];
       
       for (let question of obj.questions ) {


         if ( question instanceof Question ) {
           this.questions.push( question );

         } else {

          //check type and set object accordingly
          if ( question.step ) {
            this.questions.push( new RatingQuestion( question ) );

          } else if ( question.yes ) {
            this.questions.push( new YesNoQuestion( question ) );

          } else if ( question.selectQuestionOptions ) {
            this.questions.push( new SelectQuestion( question ) );

          } else {
            this.questions.push( new EssayQuestion( question ) );
          }


         }

       }

    }
    
  }

}